import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '../../../../../core/services/alert.service';
import { Responsible } from '../../../models/responsible';
import { ResponsiblesService } from '../../../services/responsiblesServices.service';
import { Router, ActivatedRoute } from '@angular/router';
import { assingResponsibleCustomer } from '../../../models/assingReponsibleCustomer';
import { Customer } from '../../../models/customer';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ResponsibleRequestTypeLine } from '../../../models/responsibleRequestTypeLine';
import { EventEmitter } from '@angular/core';
import {DatashareService} from '../../../services/datashare.service';
import {ResponsibleCustomer} from '../../../models/responsibleCustomer'
import { assignToCustomer } from '../../../models/assignToCustomer';
import { accountExecutive } from '../../../models/accountExecutive';


@Component({
  selector: 'kt-responsible-customer-create',
  templateUrl: './responsible-customer-create.component.html',
  styleUrls: ['./responsible-customer-create.component.scss']
})
export class ResponsibleCustomerCreateComponent implements OnInit {
  responsibleFormGroup: FormGroup;
  ResponsibleCustomer: assingResponsibleCustomer = new assingResponsibleCustomer();
  responsibleRequestType: ResponsibleRequestTypeLine[];
  @Input() customerName: string = '';
  @Input() customerId: any = '';
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  selectedFilter = '';
  mainResponsable: boolean = false;
  responsibleRequestTypeId: string = "#";

  accountExecutives: accountExecutive= new accountExecutive();
  responsibleCustomer:ResponsibleCustomer[]
  accountExecutive: accountExecutive[];
  accountExecutiveId: string = "#";
  companyId:string;
  assignToCustomer: assignToCustomer=new assignToCustomer();
  type:string;
  responsibleName:string;

  constructor(private formsBuilder: FormBuilder,
    private router: Router,
    private responsibleService: ResponsiblesService,
    private alertService: AlertService,
    private spinnerService: NgxSpinnerService,
    private activateRoute: ActivatedRoute,
    private datashareService:DatashareService

  ) { }

  ngOnInit() {   
    this.getResponsibleRequestType();
    this.getResponsibleUser();
  }

  getResponsibleUser(){
    this.responsibleService.getResponsibleUser().subscribe(
      (list:any) => {
        this.accountExecutive=list
      },
      (error) => {
        this.spinnerService.hide()
        switch (error.status) {
          case 401:
            return this.alertService.error(
              'No tiene los permisos para consultar este recurso').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 403:
            return this.alertService.error(
              'No tiene los permisos para consultar este recurso').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 500:
            return this.alertService.error(
              'Oop! Ha ocurrido un error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 0:
            return this.alertService.error(
              'Oops! Ha ocurrido un error.', 'Error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case undefined:
            return this.alertService.error(
              'Oops! Ha ocurrido un error.', 'Error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
        }
      }
      );
  }


  getResponsibleRequestType() {
    this.spinnerService.show()
    this.responsibleService.getResponsibleRequestType().subscribe(
      (list) => {
        this.responsibleRequestType = list
        this.spinnerService.hide()
      },
      (error) => {
        this.spinnerService.hide()
        switch (error.status) {
          case 401:
            return this.alertService.error(
              'No tiene los permisos para consultar este recurso').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 403:
            return this.alertService.error(
              'No tiene los permisos para consultar este recurso').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 500:
            return this.alertService.error(
              'Oop! Ha ocurrido un error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case 0:
            return this.alertService.error(
              'Oops! Ha ocurrido un error.', 'Error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
          case undefined:
            return this.alertService.error(
              'Oops! Ha ocurrido un error.', 'Error').then((result) => { if (result.value) { this.router.navigate(["/mardomgoadmin/dashboard"]) } })
        }
      }
    );
  }

  onSubmit() {

    if (this.customerId == null || this.customerId == undefined) {
      this.alertService.info('Debe seleccionar un cliente');
    }
    
    this.assignResponsibleToCustomer();
  }

  assignResponsibleToCustomer() {    
    let assingResponsibleCustomerDto = []
    this.customerId.assignCompanyList.forEach(element => {
      let data ={
        customerId:element.clientId,
        active:true,
        mainResponsible:false,
        responsibleRequestTypeId:this.responsibleRequestTypeId
      }
      assingResponsibleCustomerDto.push(data)
      
    }); 
    this.ResponsibleCustomer.customerId = this.customerId;
    this.ResponsibleCustomer.active = true;
    this.ResponsibleCustomer.mainResponsible = this.mainResponsable
    this.ResponsibleCustomer.responsibleRequestTypeId = this.responsibleRequestTypeId
     if(this.type=='responsibleRequestType'){
      let responsable =this.responsibleRequestType.find(item => item.id == this.responsibleRequestTypeId);
      this.responsibleName=responsable.responsibleName;
     }   

    this.assignToCustomer.customerId=this.customerId.assignCompanyList[0].clientId
    this.assignToCustomer.active=true;
    this.assignToCustomer.executiveid=this.accountExecutiveId;

    const data = {
      responsibleName: this.responsibleName,
      ResponsibleCustomer: {assingResponsibleCustomerDto},
      assignToCustomer:this.assignToCustomer
    }

    this.notifyParent.emit(data);
  }

  onChangeDDL(item:any,type){
    this.type=type;
    this.assignResponsibleToCustomer();
  }

  changeCheckbox(item:any){
    this.assignResponsibleToCustomer();
  }

  onSaveSuccess() {
    this.alertService.info('Cambios realizados satisfactoriamente')
      .then((result) => { 
        if (result.value) { 
          this.router.navigate(["/mardomgoadmin/customer"]) 
        } 
      });
  }

  setCustomerId(customerId: string, customerName: string) {
    this.customerId = customerId;
    this.customerName = customerName;
  }

  returnToList() {
    this.router.navigate(["/mardomgoadmin/responsible-customer"]);
  }
}